"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAction = void 0;
var UserAction;
(function (UserAction) {
    UserAction["MatchHandCount"] = "Match hand count";
    UserAction["MatchActualCount"] = "Match actual count";
})(UserAction = exports.UserAction || (exports.UserAction = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/inventory-site-lot.ts
// module id = 4103
// module chunks = 0